<template>
    <div>
        <h1>Karanteenissa Omistajana</h1>
        <p>
            hirvee omistajaflex, outfit ainaki 10 000 e
        </p>
    </div>
</template>

<script>
export default {
    name: 'omistaja',
    props: {},
    metaInfo: {
        title: 'Omistajana :D $$'
    }
}
</script>

<style scoped></style>
